import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Accordion, Button, Card, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import toppage1 from "../Images/toppage1.svg";
import toppage2 from "../Images/toppage2.png";
const Toppages = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className="mx-2">
            <h1 className="text-center m-4">
              Track the Top Performing Pages of your website
            </h1>

            <p>
              High traffic volume and SEO of your website can be compared to an
              engine pump by the middle page that creates higher importance.
              This is exactly where Seobix brings a real difference. Their Top
              Pages option, found somewhere in the link building section, will
              give you an extensive view of which of your pages are accused of
              having backlinks and then ranks the highest.
            </p>
            <div className="d-flex justify-content-center m-4">
              <img
                className=""
                src={toppage1}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <h2>Why Top Pages Matter for Your SEO Success?</h2>

            <p>
              Not all the pages on the website is performing the same . Some
              pages naturally receive more incoming links, get a higher search
              ranking, and bring more visitors. These pages perform better, and
              in fact, become your hidden treasures when it comes to SEO growth
              for your website.
            </p>

            <p>
              These pages will teach you how in learning what form of content
              works best. What is it? A blog post? A product page? A helpful
              guide? Now that you know what excites your audience and other
              websites, you can simply create more of that content. This doesn't
              just increase your chances of getting higher rankings but also
              makes your overall link building smarter and more productive.
            </p>

            <h2>How Seobix’s Top Pages Feature Helps You</h2>
            <div className="d-flex justify-content-center m-4">
              <img
                className=""
                src={toppage2}
                alt="seobix"
                style={{ width: "65vw" }}
              />
            </div>
            <p>
              Seobix helps rank and analyze pages by giving an overview of the
              best-ranked and linked pages. Seobix helps with organizing data so
              one need not guess which content is strong.
            </p>

            <p>
              These insights allow for building more backlinks to these pages to
              give them an added push in terms of ranking. They can also be
              refreshed/updated to continue attracting users as well as search
              engines. In addition, insights into the strengths of the
              top-performing pages should guide content creation for new pages
              expected to do well.
            </p>

            <p>
              Seobix makes the whole process easy, thus helping with time
              management to grow faster without cumbersome set reports or tools.
            </p>

            <h2>Why Seobix Is Your Best Choice?</h2>

            <p>
              Seobix is aimed at everyone who desires real and permanent SEO
              growth, whether for the business owner, the marketer, or the
              blogger. With easy tools like Top Pages and full support for
              link-building services, Seobix is your one-stop shop for anything
              else you need.
            </p>

            <p>
              Using Seobix doesn't require you to be an SEO expert. Our tools
              are designed for simplicity, speed, and results. All this makes it
              easy and even fun to track your top-performing pages, understand
              your backlinks, and plan what to do next.
            </p>
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Toppages;
